import { LegalPageUid } from '@modules/legal/model';

export function getLegalLink(uid: LegalPageUid) {
  return `https://www.citymag.info/legal/${uid}`;
}
